export default "__VITE_ASSET__CWqJ$Z$m__"